<template>
    <v-list nav dense>
        <v-subheader class="pl-0">
            <v-hover v-slot:default="{ hover }">
                <v-btn small text color="grey darken-1" class="text-caption" @click="$emit('update:expanded', !expanded)">
                    INSTANCE
                    <v-icon v-if="hover" right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-hover>
        </v-subheader>
        <v-expand-transition>
            <div v-show="expanded">
                <InstanceMenu :collapsed="collapsed" :show-quick-actions="true" />

                <v-list-item
                    v-if="!isTrialSpace"
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    e2e-sidebar-snapshots
                    active-class="primary--text"
                    :to="{
                        name: 'instance-snapshots',
                        params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid },
                        query: $route.query
                    }"
                    e2e-sidebar-view-timeline>
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-camera-outline</v-icon>
                            </template>
                            <span>Snapshots</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Snapshots</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="isSpaceAdmin && isDevelopment && !isSpaceArchived && !isSpaceInAnyRestState && !collapsed" class="my-0">
                        <SnapshotCreateButton compact />
                    </v-list-item-action>
                </v-list-item>

                <v-list-item
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    active-class="primary--text"
                    :to="{
                        name: 'snapshot-overview',
                        params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid },
                        query: $route.query
                    }">
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-view-dashboard-outline</v-icon>
                            </template>
                            <span>Overview</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Overview</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- <div class="my-4"></div> -->

                <v-list-item
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    :disabled="isInstanceObserver"
                    active-class="primary--text"
                    :to="{
                        name: 'snapshot-files',
                        params: {
                            oid: $route.params.oid,
                            sid: $route.params.sid,
                            iid: $route.params.iid,
                            snid: $route.params.snid,
                            localPath: currentFileLocalPath,
                            fileArea: fileAreaType
                        },
                        query: $route.query
                    }"
                    @click="clearPathArray"
                    e2e-sidebar-files>
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-folder-outline</v-icon>
                            </template>
                            <span>Files</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Files</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    :disabled="isInstanceObserver"
                    active-class="primary--text"
                    :to="{
                        name: 'snapshot-tables',
                        params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid },
                        query: $route.query
                    }"
                    e2e-sidebar-tables>
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-table-large</v-icon>
                            </template>
                            <span>Tables</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Tables</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    :disabled="isInstanceObserver"
                    active-class="primary--text"
                    :to="{
                        name: 'snapshot-applications',
                        params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid },
                        query: $route.query
                    }"
                    e2e-sidebar-apps>
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-monitor</v-icon>
                            </template>
                            <span>Applications</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Applications</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="!isInstanceObserver && !isSpaceArchived && !isSpaceInAnyRestStateExceptPreResting && !collapsed" class="my-0">
                        <v-btn
                            v-if="canDirectlyAddApplication"
                            text
                            small
                            class="px-2"
                            min-width="0"
                            :to="{
                                name: 'snapshot-applications-add',
                                params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid }
                            }"
                            :disabled="applicationsFetching"
                            @click.stop>
                            <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                        <v-dialog v-else v-model="addAppDialog" max-width="500" persistent>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text small class="px-2" min-width="0" v-bind="attrs" v-on="on" @click.stop.prevent :disabled="applicationsFetching">
                                    <v-icon small>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title class="flex-nowrap align-start">
                                    <span class="secondary--text">Insufficient privileges</span>

                                    <v-spacer></v-spacer>
                                    <v-btn @click="addAppDialog = false" icon><v-icon>clear</v-icon></v-btn>
                                </v-card-title>

                                <v-card-text class="mt-1">
                                    <p>
                                        New applications can be added only by course admins. If you require an additional application for your work, please ask
                                        a course admin to add the application. As a reference, they can do it at the current URL:
                                    </p>
                                    <div class="d-flex align-center justify-space-between mt-2">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <span class="secondary--text text-truncate" v-on="on">{{ currentURL.substring(0, 100) }}...</span>
                                            </template>
                                            <span>{{ currentURL }}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on">
                                                    <CopyToClipboard :textToCopy="currentURL" buttonColor="secondary" :iconButton="true" :isSmall="true" />
                                                </div>
                                            </template>
                                            <span>Copy to clipboard</span>
                                        </v-tooltip>
                                    </div>
                                </v-card-text>

                                <v-card-actions></v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-list-item-action>
                </v-list-item>

                <!-- <div class="my-4"></div> -->

                <v-list-item
                    :class="['overflow-visible', { 'ml-2 drawer-active-item': !collapsed }]"
                    :disabled="isInstanceObserver"
                    active-class="primary--text"
                    :to="{
                        name: 'snapshot-distribute',
                        params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid },
                        query: $route.query
                    }"
                    e2e-sidebar-sharing>
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-badge
                                    :color="numberOfStagedObjects > 0 ? 'primary' : 'secondary'"
                                    :offset-y="8"
                                    overlap
                                    class="caption ma-0"
                                    v-model="showBadge">
                                    <v-icon v-bind="attrs" v-on="on">mdi-share-variant-outline</v-icon>
                                    <template v-slot:badge>
                                        <v-fab-transition>
                                            <span v-text="numberOfStagedObjects" fab></span>
                                        </v-fab-transition>
                                    </template>
                                </v-badge>
                            </template>
                            <span>Staging</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Staging</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="currentSpaceType === spaceTypes.EDUCATION_SPACE"
                    :class="[{ 'primary--text': isAssignmentsRoute }, { 'ml-2 drawer-active-item': !collapsed }]"
                    :disabled="isInstanceObserver"
                    active-class="primary--text"
                    :to="{
                        name: 'snapshot-assignments',
                        params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid },
                        query: $route.query
                    }"
                    e2e-sidebar-assignments>
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-clipboard-text-outline</v-icon>
                            </template>
                            <span>Assignments</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Assignments</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-if="isVideoLibraryEnabled"
                    :class="[{ 'primary--text': isVimeoRoute }, { 'ml-2 drawer-active-item': !collapsed }]"
                    :disabled="isInstanceObserver"
                    active-class="primary--text"
                    :to="{
                        name: 'vimeo-videos',
                        params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid },
                        query: $route.query
                    }"
                    e2e-sidebar-videos>
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-play-box-multiple-outline</v-icon>
                            </template>
                            <span>Video Library</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Video Library</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </div>
        </v-expand-transition>
    </v-list>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { enumsData } from '@/mixins/enums'
import { snapshotEnums } from '@/mixins/snapshot'
const InstanceMenu = () => import('@/components/InstanceMenu.vue')
const CopyToClipboard = () => import('@/components/CopyToClipboard.vue')
const SnapshotCreateButton = () => import('@/components/SnapshotCreateButton.vue')

export default {
    name: 'DrawerInstanceSection',
    components: {
        InstanceMenu,
        CopyToClipboard,
        SnapshotCreateButton
    },
    mixins: [enumsData, snapshotEnums],
    props: {
        collapsed: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showBadge: false,
            addAppDialog: false
        }
    },
    computed: {
        ...mapGetters('instanceStore', ['isInstanceEditor', 'isInstanceObserver']),
        ...mapGetters('spaceStore', [
            'currentSpaceType',
            'isTrialSpace',
            'isSpaceArchived',
            'isSpaceInAnyRestState',
            'isSpaceInAnyRestStateExceptPreResting',
            'isSpaceAdmin'
        ]),
        ...mapGetters('snapshotStore', ['currentFileLocalPath', 'isDevelopment']),
        ...mapState('snapshotStore', ['stagingObjects', 'fileAreaType', 'applicationsFetching']),
        ...mapState('spaceStore', ['currentSpace']),
        canDirectlyAddApplication() {
            return (
                (this.isDevelopment && this.isSpaceAdmin) ||
                (this.isDevelopment && this.currentSpaceType !== this.spaceTypes.EDUCATION_SPACE && this.isInstanceEditor)
            )
        },
        currentURL() {
            return window.location.href
        },
        numberOfStagedObjects() {
            if (!this.stagingObjects) {
                return 0
            }

            return (this.stagingObjects.files?.length || 0) + (this.stagingObjects.tables?.length || 0) + (this.stagingObjects.applications?.length || 0)
        },
        isAssignmentsRoute() {
            return (
                ['snapshot-assignments', 'assignment', 'handin', 'handback'].includes(this.$route.name) ||
                (this.$route.name === 'app-open' && Boolean(this.$route.query.grading))
            )
        },
        isVimeoRoute() {
            return this.$route.name === 'vimeo-videos'
        },
        isVideoLibraryEnabled() {
            return Boolean(this.currentSpace && this.currentSpace.vimeo_enabled)
        }
    },
    watch: {
        numberOfStagedObjects: {
            immediate: true,
            handler(nextValue, preValue) {
                if (nextValue !== preValue) {
                    this.showBadge = false
                    setTimeout(() => {
                        this.showBadge = nextValue > 0
                    }, 300)
                }
            }
        }
    },
    methods: {
        clearPathArray() {
            this.$store.dispatch('snapshotStore/setPathArray', [''])
        }
    }
}
</script>
